<template>
  <b-card>
    <alert ref="alert" />
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-tabs card>
      <b-tab title="New Password Setup" title-link-class="nav-link-custom" active>
        <b-row v-if="passwordChangeIsSuccessful" class="row offset-2 col-5">
          <span class="w-100">You password has been successfully changed.</span>
          <a href="/" class="w-100">Back to the main screen</a>
        </b-row>
        <b-row v-else class="row offset-2 col-5">
          <b-form @submit="onSubmit" class="w-100" align="center">
            <b-form-group label="User Name" label-class="text-left">
              <b-form-input :type="text" v-model="routeParams.userName" disabled size="sm"></b-form-input>
            </b-form-group>
            <b-form-group label="New password" label-for="newPassword" label-class="text-left">
              <ValidationProvider name="newPasswordProvider" rules="required" v-slot="v">
                <b-input-group>
                  <b-form-input
                    id="newPassword"
                    :type="inputTypes.newPassword" v-model="form.newPassword"
                    required
                    placeholder="New password"
                    aria-describedby="newPasswordErrors"
                    size="sm">
                  </b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="info"
                      @mousedown="inputTypes.newPassword = 'text'"
                      @mouseup="inputTypes.newPassword = 'password'"
                      class="pwd-btn"
                      size="sm">
                      <b-icon-eye-slash v-if="inputTypes.newPassword == 'password'" size="sm"></b-icon-eye-slash>
                      <b-icon-eye-fill v-else size="sm"></b-icon-eye-fill>
                    </b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback style="display: block; text-align: left" id="newPasswordErrors">{{ v.errors[0] }}</b-form-invalid-feedback>
                </b-input-group>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="New password (confirmation)" label-for="newPasswordConfirmation" label-class="text-left">
              <ValidationProvider name="newPasswordConfirmationProvider" rules="required|password:@newPasswordProvider" v-slot="v">
                <b-input-group>
                  <b-form-input
                    id="newPasswordConfirmation"
                    :type="inputTypes.confirmNewPassword"
                    v-model="form.confirmNewPassword"
                    required
                    placeholder="New password (confirmation)" size="sm"></b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="info"
                      @mousedown="inputTypes.confirmNewPassword = 'text'"
                      @mouseup="inputTypes.confirmNewPassword = 'password'"
                      aria-describedby="newPasswordConfirmationErrors"
                      class="pwd-btn"
                      size="sm">
                      <b-icon-eye-slash v-if="inputTypes.confirmNewPassword == 'password'" size="sm"></b-icon-eye-slash>
                      <b-icon-eye-fill v-else size="sm"></b-icon-eye-fill>
                    </b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback style="display: block; text-align: left" id="newPasswordConfirmationErrors">{{ v.errors[0] }}</b-form-invalid-feedback>
                </b-input-group>
              </ValidationProvider>
            </b-form-group>

            <b-button
              :disabled="form.newPassword === '' || form.newPassword !== form.confirmNewPassword"
              type="submit" variant="primary" size="sm" class="float-right">Change</b-button>
          </b-form>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import Alert from '../Alert';

import axios from 'axios';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

axios.defaults.baseURL = API_BASE_URL;

extend('required', {
  ...required,
  message: 'This field is required'
});

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});

export default {
  props: {
    path: String
  },
  data() {
    return {
      routeParams: {
        userId: this.$route.params.userId,
        userName: this.$route?.query?.userName,
        code: this.$route?.query?.code
      },
      form: {
        newPassword: '',
        confirmNewPassword: ''
      },
      inputTypes: {
        newPassword: 'password',
        confirmNewPassword: 'password'
      },
      passwordChangeIsSuccessful: false,
      showSpinner: false,
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      }
    };
  },
  methods: {
    async onSubmit(evt) {
      this.showSpinner = true;
      evt.preventDefault();
      try {
        let res = await axios.post('/users/reset/callback', {
          'UserId': this.routeParams.userId,
          'Code': this.routeParams.code,
          'NewPassword': this.form.newPassword
        });
        this.passwordChangeIsSuccessful = true;
      } catch (err) {
        this.passwordChangeIsSuccessful = false;
        this.$refs.alert.showAlert('danger', 'Failed to reset the password.');
      } finally {
        this.showSpinner = false;
      }
    }
  },
  components: {
    Alert,
    ValidationProvider
  }
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  .nav-link-custom,
  &.active {
    border-color: #dee2e6 !important;
    border-radius: 0.25rem !important;
  }
}

.pwd-btn {
  padding: 0.25rem 0.35rem;
}
</style>
